import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

const DeviceSelector = ({ selectedDevices, onUpdateSelectedDevices, deviceList }) => {
  const getDeviceOptions = () => deviceList.map((device) => ({
    label: `${device.displayName}`,
    value: device.id,
  }));

  const onUpdateSelected = (newSelectedDevices) => {
    onUpdateSelectedDevices(newSelectedDevices);
  };

  return (
    <>
      <Select
        isMulti
        isClearable={false}
        defaultValue={[]}
        options={getDeviceOptions()}
        onChange={onUpdateSelected}
        value={selectedDevices}
        placeholder="All Devices"
        aria-label="select devices"
      />
    </>
  );
};

DeviceSelector.propTypes = {
  selectedDevices: PropTypes.arrayOf(
    PropTypes.shape({ name: PropTypes.string, uuid: PropTypes.string }),
  ).isRequired,
  onUpdateSelectedDevices: PropTypes.func.isRequired,
  deviceList: PropTypes.arrayOf(
    PropTypes.shape({ name: PropTypes.string, uuid: PropTypes.string }),
  ).isRequired,
};

export default DeviceSelector;
